/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import BreadCrumbs from "./BreadCrumbs.container";

export default BreadCrumbs;
